module.exports = __webpack_public_path__ + "static/media/remove-icon.32b799ab.svg";